import axios from 'axios'
import { ActionTypes } from '../constants'
import { devLog } from '../functions'

export const catchError = (error) =>{
    if( error.response ){
        console.error(error.response);
    }
    else if (error.request) {
        console.error('The request was made but no response was received');
    }
    else{
        console.error('Something happened in setting up the request that triggered an Error');
        console.error('Error', error.message);
    }
    return true;
}

// actions
// 見積もり計算
export const calcPrice = (addCartFlg=false) => async (dispatch,getState) => {
    dispatch( checkRules() );
    const state = getState()
    let flgError = false
    const areas = state.areas.list.map((area)=>{
        if( area.error ){
            flgError = true
        }
        return {
            id:area.id,
            num:area.num,
        }
    })

    Object.keys( state.areas.errors ).forEach( k =>{
        if( state.areas.errors[k] !== null ){
            flgError = true
        }
    })
    //エラーが有る場合は計算しない
    if( flgError ){
        dispatch({ type: ActionTypes.CALC_PRICE, estimate:{}, error:{} });
        return;
    }
    const options = {
        ...state.options.selected,
        date: state.calendar.selected
    }
    let errFlg = false
    const response = await axios({
        method: 'POST',
        withCredentials: true,
        url: process.env.REACT_APP_API_URL,
        data: {
            mode:'calc_price',
            areaIds:state.areas.areaIds,
            areas:areas,
            options:options,
            addCartFlg:addCartFlg,
            admin:false,
        },
    }).catch( (e)=>{ errFlg = catchError(e) } );
    if (errFlg) return;

    if ( 'data' in response && typeof(response.data) === 'object'){
        if ( 'totalPriceTax' in response.data ) {
            if( addCartFlg ){
                devLog('calcPrice goCart',response.data);
                window.location.href = process.env.REACT_APP_CART_URL;
            }
            devLog('calcPrice response.data',response.data);
            dispatch({ type: ActionTypes.CALC_PRICE, estimate:response.data, error:{} });
        }
        else if( 'error' in response.data ) {
            console.error('calcPrice response error',response.data.error);
            dispatch({ type: ActionTypes.CALC_PRICE, estimate:{}, error:response.data.error });
        }
        else{
            devLog('calcPrice response',response.data);
            dispatch({ type: ActionTypes.CALC_PRICE, estimate:{}, error:{} });
        }
    }
    else{
        console.error('calcPrice irregular response',response.data);
        dispatch({ type: ActionTypes.CALC_PRICE, estimate:{}, error:{server:'irregular response'} });
    }
}

export const checkRules = () => (dispatch,getState) =>{
    const {areas ,options} = getState()
    let error = null
    options.rules.restrictSpeedByArea.forEach((rule)=>{
        const speedTypeId = rule.speedTypeId
        if( options.selected.speedTypeId !== speedTypeId ){
            const areaIds = rule.areaIds
            const hitAreas = areas.list.filter( a =>
                ( areaIds.indexOf(a.id) > -1 )
                || ( areaIds.indexOf(a.parent_id) > -1 )
                || ( areaIds.indexOf(a.grandparent_id) > -1 )
            )

            if(hitAreas.length > 0){
                error = rule.msg
                console.error('checkRules():',error)
                hitAreas.forEach(a=>{
                    console.error('checkRules():',a.name+':このエリアはこの配布期間を選択することができません。')
                })
            }
        }
    })
		dispatch ({ type: ActionTypes.ERROR_AREAS, key: 'restrictSpeedByArea', msg: error })
		dispatch ({ type: ActionTypes.ERROR_OPTIONS, key: 'speedType', msg: error })

    // 住居指定不可、軒並みのみ
    error = null
    if( options.selected.houseTypeId !== 'n' ){
        const areaIds = options.rules.NormalHouseTypeByArea.areaIds
        const hitAreas = areas.list.filter( a =>
            ( areaIds.indexOf(a.id) > -1 )
            || ( areaIds.indexOf(a.parent_id) > -1 )
            || ( areaIds.indexOf(a.grandparent_id) > -1 )
        )

        if(hitAreas.length > 0){
            error = options.rules.NormalHouseTypeByArea.msg
            console.error('checkRules():',error)
            hitAreas.forEach(a=>{
                console.error('checkRules():',a.name+':',error)
            })
        }
    }
		dispatch ({ type: ActionTypes.ERROR_AREAS, key: 'NormalHouseTypeByArea', msg: error })
		dispatch ({ type: ActionTypes.ERROR_OPTIONS, key: 'houseType', msg: error })

    // エリア別注釈を切り替える
    {
        const areaNotes = [];
        options.rules.AreaNote.forEach((rule)=>{
            const areaIds = rule.areaIds
            const hitAreas = areas.list.filter( a =>
                ( areaIds.indexOf(a.id) > -1 )
                || ( areaIds.indexOf(a.parent_id) > -1 )
                || ( areaIds.indexOf(a.grandparent_id) > -1 )
            )

            if(hitAreas.length > 0){
                areaNotes.push(rule.text)
            }
        })
        dispatch ({ type: ActionTypes.SET_AREA_NOTE, areaNotes })
    }
}


// WEBPACK FOOTER //
// ./src/actions/index.js